module.exports = __webpack_public_path__ + "static/media/vyaz.4c3b8a97.jpg";